module.exports = __webpack_public_path__ + "4690fdc7d2f405813ea18768b741fde6.png";